import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * カメラアイコン
 */
const ErrorIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="14.4"
        viewBox="0 0 16 14.4"
      >
        <path
          d="M16.4,3.6H13.864L12.4,2H7.6L6.136,3.6H3.6A1.6,1.6,0,0,0,2,5.2v9.6a1.6,1.6,0,0,0,1.6,1.6H16.4A1.6,1.6,0,0,0,18,14.8V5.2A1.6,1.6,0,0,0,16.4,3.6Zm0,11.2H3.6V5.2H6.84L8.3,3.6H11.7L13.16,5.2H16.4ZM10,6a4,4,0,1,0,4,4A4,4,0,0,0,10,6Zm0,6.4A2.4,2.4,0,1,1,12.4,10,2.407,2.407,0,0,1,10,12.4Z"
          transform="translate(-2 -2)"
        />
      </svg>
    </Icon>
  )
}

export default ErrorIcon
